export const USER_INPUT_INPUT = 'USER_INPUT_INPUT' as const;
export const USER_INPUT_OUTPUT = 'USER_INPUT_OUTPUT' as const;
